import CashbackPage from './CashbackPage';

export default CashbackPage;
